export const taxesCalculation = (row, index) => {
	if (Number(row[index].mrp) !== 0 && Number(row[index].quantity) !== 0) {
		let totalTaxes = Number(row[index]?.product_tax1 || 0) + Number(row[index]?.product_tax2 || 0);
		let baseAmount =
			Number(Number(row[index].mrp) * Number(row[index].quantity)) -
			Number(
				(Number(row[index].mrp) * Number(row[index].quantity) * Number(totalTaxes)) /
					Number(100 + Number(totalTaxes)),
			);
		let newRow = [...row];
		newRow[index].amount = Number(baseAmount).toFixed(2);
		return newRow;
	} else {
		return row;
	}
};
export const totalAmountWithoutTax = (amount, tax1, tax2) => {
	let totalTaxes = Number(tax1) + Number(tax2);
	let baseAmount =
		Number(amount) -
		Number((Number(amount) * Number(totalTaxes)) / Number(100 + Number(totalTaxes)));
	return Number(baseAmount).toFixed(2);
};
export const getRoundedOffAmount = (amount) => {
	const roundedTotal = amount % 1 >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
	return Number(roundedTotal).toFixed(2);
};

export const getRoundedOff = (amount) => {
	const roundedTotal = amount % 1 >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
	const roundOff = parseFloat((roundedTotal - amount).toFixed(2));
	return roundOff;
};
